import { Upsell } from "@/@types/Upsell";
import { Button } from "@/components/ui/button";
import { toast } from "@/hooks/use-toast";
import { Check, Copy } from "lucide-react";
import { ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  title: ReactNode;
  script: string
}

export function ScriptComponent({ title, script }: Props) {
  const { t } = useTranslation("upsells");
  const [copied, setCopied] = useState(false);


  const handleCopy = (event: React.MouseEvent) => {
    event.preventDefault();

    navigator.clipboard.writeText(script);
    toast({
      variant: "success",
      description: t("finishStep.copySuccess"),
    });
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="flex-1 max-[400px]:w-5/6">
      <div className="flex justify-between items-center max-sm:flex-col max-sm:items-start max-sm:gap-2">
        <span className="text-sm text-zinc-100">
          {title}
        </span>
        <Button
          size="sm"
          variant="outline"
          disabled={copied}
          onClick={handleCopy}
          className="h-8 bg-[#18181B] hover:bg-zinc-700 text-zinc-100 border-zinc-700"
        >
          {copied ? (
            <Check className="mr-2 h-4 w-4" />
          ) : (
            <Copy className="mr-2 h-4 w-4" />
          )}
          {t("finishStep.copyButton")}
        </Button>
      </div>

      <div className="mt-3 space-y-2">
        <div className="bg-[#1A1A1A] rounded-lg p-3 overflow-auto">
          <pre className="whitespace-pre-wrap text-[#A1A1AA] text-xs font-mono">
            {script}
          </pre>
        </div>
      </div>
    </div>
  );
}
